import getApiClient from '@/shared/api/api-client/getApiClient';

export async function enableFacebookBeta(key: string): Promise<{ errorMessage: string; isOk: false } | { isOk: true }> {
  const client = getApiClient();
  const response = await client.post('/api/facebook/beta/enable', { json: { key } });

  if (!response.ok) {
    return { errorMessage: await response.errorMessage(), isOk: false };
  }

  return { isOk: true };
}
